import React, { useContext, useState } from 'react';
import { ThemeContext } from 'src/emerald-theme-provider';
import defaultCustomerCartLogo from 'src/common/media/CustomerCart.svg';

interface CartLogoProps {
  styles?: string;
}

const CustomerCartLogo: React.FC<CartLogoProps> = ({ styles }: CartLogoProps): JSX.Element => {
  const { emeraldTheme } = useContext(ThemeContext);
  const cartImage = emeraldTheme?.customerDisplay?.cartImageURL;
  const [showImage, setShowImage] = useState<boolean>(true);

  return showImage && cartImage ? (
    <img
      src={cartImage}
      className={styles}
      alt='customer-cart-logo'
      onError={() => {
        setShowImage(false);
      }}
      data-testid='customer-display-cart'
    />
  ) : (
    <img
      src={defaultCustomerCartLogo}
      className={styles}
      alt='default-cart-logo'
      data-testid='customer-display-cart-default'
    />
  );
};

export default CustomerCartLogo;
